import { render } from "./IconInvestedRoundedType3.vue?vue&type=template&id=4b3d3ff1&ts=true"
import script from "./IconInvestedRoundedType3.vue?vue&type=script&lang=ts"
export * from "./IconInvestedRoundedType3.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__